import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { Redirect } from 'react-router-dom';
// Importação da tabela
import TopoEstatico from '../Layout/TopoEstatico';
import Loading from '../Miscelania/Loading';
import Alerta from '../Miscelania/Alerta';
import RequestApi from '../Miscelania/RequestApi';

class ExamConfirmation extends Component {
  desativar_loading () {
    this.setState({status_loading: 0});
  } 
  desativar_alerta () {
    this.setState({status_alerta: 0});
  } 

  // Handlers de form
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  constructor(props) {
    super(props);

    this.state = {
      status_loading: 0,
      redirect_url: false,
      mensagem_alerta: false,
      tipo_alerta: false,
      status_alerta: false,
      modal: false,
      loaded: 0,
      data: [],
    };
    this.desativar_loading = this.desativar_loading.bind(this);
    this.desativar_alerta = this.desativar_alerta.bind(this);
    this.openExam = this.openExam.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  componentDidMount () {
    this.refs.request_api.header();
    this.loadData();
  }

  // Buscar infos do categoria
  loadData(e) {
    var url = config.get('api') + '/aluno/prova/acesso/'+this.props.match.params.id;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({ staff_name: responseJson.data.staff.name, matter_name: responseJson.data.matter.name});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      });
    });
  }

  // Buscar infos da prova selecionada
  openExam(event) {
    var url = config.get('api') + '/prova/usuario/liberar/'+ this.props.match.params.id;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    if(window.confirm('Confirma que concluiu o treinamento da matéria ' + this.state.matter_name + '?')) {
      Promise.resolve(header).then(function(value) {
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success' || responseJson.status === 'warning') {
            var url = '/usuario/provas';
            var storage = {
              mensagem_alerta: responseJson.message,
              tipo_alerta: responseJson.status,
            };
            localStorage.setItem("verifica_mensagem", JSON.stringify(storage));
            self.setState({redirect_url: url});
          } else {
            self.setState({status_alerta: 1});
            self.setState({mensagem_alerta: responseJson.message});
            self.setState({tipo_alerta: responseJson.status});
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {

    var self = this;
    return (
<div>
  <TopoEstatico />
  <RequestApi ref={'request_api'} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  {(this.state.status_loading !== 0) ? <Loading ativo={this.state.status_loading} desativar={this.desativar_loading} />: ""}
  {(this.state.status_alerta === 1) ? <Alerta mensagem={this.state.mensagem_alerta} tipo={this.state.tipo_alerta} desativar={this.desativar_alerta} /> : ""}
  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <h1>ATENÇÃO</h1>
        <p>Prezado, {this.state.staff_name}</p>
        <p>Clique no botão abaixo para confirmar a conclusão do treinamento {this.state.matter_name} e liberar a prova caso aplicável.</p>
        <br/>
        <button onClick={this.openExam} className="btn btn-info btn-lg btn-block"><i className="fa fa-fw fa-refresh"></i> Declaro que concluí o treinamento.</button>
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default ExamConfirmation;


// WEBPACK FOOTER //
// ./src/Components/Exams/ExamConfirmation.js